(() => {
  const allowed = ['XS','S','M','L','XL','2XL','3XL','OTHER','ALL'];

  function init(root) {
    if (!root || root.dataset.riInitialized === 'true') return;
    root.dataset.riInitialized = 'true';

    const grid = root.querySelector('[data-ri-size-grid]');
    const status = root.querySelector('[data-ri-size-status]');
    const title = root.querySelector('[data-ri-size-title]');
    const current = root.dataset.currentProduct;
    const limit = Math.max(2, Math.min(8, Number(root.dataset.limit) || 4));
    let selected = root.dataset.size || 'ALL';
    let catalog = null;
    let loading = null;
    let requestVersion = 0;

    async function loadCatalog() {
      if (catalog) return catalog;
      if (loading) return loading;

      loading = (async () => {
        let page = 1;
        const seen = new Set();
        const cards = new Map();

        while (page) {
          if (seen.has(page) || seen.size >= 10) throw new Error('catalog pagination failed');
          seen.add(page);

          const url = new URL(root.dataset.catalogUrl, location.origin);
          url.searchParams.set('section_id', root.dataset.section);
          url.searchParams.set('filter.v.availability', '1');
          url.searchParams.set('sort_by', 'created-descending');
          url.searchParams.set('page', String(page));

          const response = await fetch(url, {
            credentials: 'same-origin',
            cache: 'no-store'
          });
          if (!response.ok) throw new Error('catalog request failed');

          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const pageRoot = doc.querySelector('[data-ri-catalog-page]');
          if (!pageRoot) throw new Error('catalog response missing');

          pageRoot.querySelectorAll('.ri-card[data-ri-product-id]').forEach(card => {
            if (card.dataset.riSizes) cards.set(card.dataset.riProductId, card);
          });

          const next = pageRoot.dataset.riNextPage;
          page = next ? Number(next) : 0;
          if (next && (!Number.isInteger(page) || page < 1)) throw new Error('invalid catalog page');
        }

        catalog = Array.from(cards.values());
        return catalog;
      })();

      try {
        return await loading;
      } finally {
        loading = null;
      }
    }

    async function select(size) {
      if (!allowed.includes(size)) size = 'ALL';
      selected = size;
      const version = ++requestVersion;

      root.querySelectorAll('[data-ri-size-choice]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.riSizeChoice === size));
      });

      title.textContent =
        size === 'ALL' ? 'All available sizes' :
        size === 'OTHER' ? 'Other available sizes' :
        'Available in ' + size;

      grid.setAttribute('aria-busy', 'true');
      status.textContent = 'Finding available pieces…';

      try {
        const allCards = await loadCatalog();
        if (!root.isConnected || version !== requestVersion || selected !== size) return;

        const matches = allCards.filter(card => {
          if (card.dataset.riProductId === current) return false;
          return size === 'ALL' || card.dataset.riSizes.includes('|' + size + '|');
        });

        const nodes = matches.slice(0, limit).map(card => {
          const copy = card.cloneNode(true);
          if (size !== 'ALL') {
            const variant = Array.from(copy.querySelectorAll('[data-ri-variant-size]')).find(v => v.dataset.riVariantSize === size);
            if (variant) copy.querySelector('.ri-card__link')?.setAttribute('href', variant.dataset.riVariantUrl);
          }
          return copy;
        });

        grid.replaceChildren(...nodes);
        if (nodes.length) {
          status.textContent = nodes.length + ' available piece' + (nodes.length === 1 ? '' : 's') + (size === 'ALL' ? '.' : ' in ' + size + '.');
        } else {
          status.textContent = size === 'ALL'
            ? 'No other available pieces were found right now.'
            : 'Nothing else in ' + size + ' right now — try another size.';
        }
      } catch (error) {
        if (!root.isConnected || version !== requestVersion) return;
        grid.replaceChildren();
        status.textContent = 'Could not load size matches right now. Use Browse all available above.';
      } finally {
        if (version === requestVersion) grid.setAttribute('aria-busy', 'false');
      }
    }

    root.addEventListener('click', event => {
      const button = event.target.closest('[data-ri-size-choice]');
      if (!button || !root.contains(button)) return;
      select(button.dataset.riSizeChoice);
    });

    select(selected);
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-ri-product-size-shop]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();